var map = {
	"./basic_bw.svg": 14,
	"./io_bw.svg": 16,
	"./simquadrat_bw.svg": 5,
	"./sipgate_bw.svg": 19,
	"./team_bw.svg": 21,
	"./trunking_bw.svg": 23
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7;


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns ^\.\/.*_bw\.svg$
// module id = 7
// module chunks = 0